import React, { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch } from "react-redux";
import {
  setAppoveModal,
  setDeny,
  setEditSlider,
} from "../../../../slices/invitationSlice";
import styles from "./historyandPendingStyles";

const PendingApproval = React.memo(
  ({ data }) => {
    const dispatch = useDispatch();

    return (
      <Box sx={styles.container}>
        <Box sx={styles.section}>
          <Box sx={styles.card}>
            <Box sx={{ display: "flex", gap: "8px" }}>
              <div className="flex flex-row gap-1">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M11 7.00098H13V9.00098H11V7.00098ZM11 11.001H13V17.001H11V11.001ZM12 2.00098C6.48 2.00098 2 6.48098 2 12.001C2 17.521 6.48 22.001 12 22.001C17.52 22.001 22 17.521 22 12.001C22 6.48098 17.52 2.00098 12 2.00098ZM12 20.001C7.59 20.001 4 16.411 4 12.001C4 7.59098 7.59 4.00098 12 4.00098C16.41 4.00098 20 7.59098 20 12.001C20 16.411 16.41 20.001 12 20.001Z"
                    fill="#0078A7"
                  />
                </svg>
                <div>
                  <Typography sx={styles.typography}>
                    Approve {data.firstName} {data.lastName}'s request?
                  </Typography>
                </div>
              </div>
            </Box>
            <Box sx={styles.actionsContainer}>
              <Box
                sx={styles.buttonBox}
                onClick={() => {
                  dispatch(setAppoveModal(true));
                  dispatch(setDeny(true));
                }}
              >
                <Typography sx={styles.buttonText}>Reject</Typography>
                <CloseIcon
                  sx={{ height: "20px", width: "20px", fill: "#005CBC" }}
                />
              </Box>
              <Box
                sx={styles.buttonBox}
                onClick={() => {
                  dispatch(setEditSlider(true));
                }}
              >
                <Typography sx={styles.buttonText}>Edit request</Typography>
                <EditOutlinedIcon
                  sx={{ height: "20px", width: "20px", fill: "#005CBC" }}
                />
              </Box>
              <Box
                sx={styles.buttonBox}
                onClick={() => {
                  dispatch(setAppoveModal(true));
                  dispatch(setDeny(false));
                }}
              >
                <Typography sx={styles.buttonText}>Approve</Typography>
                <CheckOutlinedIcon
                  sx={{ height: "20px", width: "20px", fill: "#005CBC" }}
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    );
  },
  (prevProps, nextProps) => {
    // Compare the previous and next props
    return JSON.stringify(prevProps.data) === JSON.stringify(nextProps.data);
  }
);

export default PendingApproval;
